/* eslint-disable */
import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
import PopClassHistory from './_PopClassHistory';
import PopPay from './_PopPay';
import PopConfirm from './_PopConfirm';
import ClassRegister from '../../component/student/ClassRegister';
function PopClassChange(props) {
  const [modalOpenClassHistory, setModalOpenClassHistory] = useState(false);
  const [modalOpenPay, setModalOpenPay] = useState(false);
  const [modalConfirm, setModalConfirm] = useState(false);
  const {open, close} = props;
  return (
    <>
      <Modal open={open} close={close}>
        <h2 className="pop_tit line">수업변경</h2>
        <div className="content_container scroll">
          <ClassRegister />
        </div>
        <div className="btn_container">
          <button
            onClick={() => {
              setModalConfirm(true);
            }}
            className="com_btn orange xs"
          >
            변경내용 저장
          </button>
          <button
            onClick={() => {
              setModalOpenPay(true);
            }}
            className="com_btn orange xs"
          >
            결제하기
          </button>
        </div>
      </Modal>
      <PopClassHistory open={modalOpenClassHistory} close={() => setModalOpenClassHistory(false)} />
      <PopPay open={modalOpenPay} close={() => setModalOpenPay(false)} />
      <PopConfirm open={modalConfirm} close={() => setModalConfirm(false)} />
    </>
  );
}

export default PopClassChange;
